<template>
    <div class="change-status" :class="{'waiting' : isWaiting}">
        <!--  指定队长 -->
        <dl class="change-dl appoint-captain" v-if="isCaptain">
            <dt class="change-dt">
                <h2 class="change-dt-h2">队长指定</h2>
            </dt>
            <dd class="change-dd">
                <ul class="change-dl-ul">
                    <li v-for="(player, pindex) in infos"
                        :key="pindex"
                        class="change-dl-li"
                        :class="setLiCls(player)"
                        @click="changeCaptain(player)"
                    >
                        <em v-show="captain == player.username" class="iscaptain">队长</em>
                        <img :src="player.avatar" class="change-avatar">
                        <p>{{ getUserStatus(player.status) }}</p>
                    </li>
                </ul>
            </dd>
        </dl>
        <!-- 指定队长 end  -->
        <!-- 更改状态  -->
        <dl class="change-dl mystatus-change">
            <dt class="change-dt">
                <h2 class="change-dt-h2">更改状态</h2>
            </dt>
            <dd class="change-dd">
                <ul class="change-dl-ul">
                    <li v-for="(status, sindex) in statusArr"
                        :key="sindex"
                        class="change-dl-li"
                        :class="{'active': myStatus == status}"
                        :data-index="status"
                        @click="changePlayerStatus(status)"
                    >
                        <p class="mystatus-change-p">{{ getUserStatus(status) }}</p>
                    </li>
                </ul>
            </dd>
        </dl>
        <!-- 更改状态 end  -->
    </div>
</template>

<script>
    import { getPlayerStatus } from "@/common/fns";
    import { STATUS } from "@/common/const";
    import { postOnline, postOutline, postCaptain } from "@/api/post";
    import { dialog } from "@/common/fns";

    export default {
        name: "change-status",
        props: {
            infos: {
                type: Array,
                default() {
                    return []
                }
            },
            isCaptain: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            captain: {
                type: String,
                default() {
                    return 'nobody'
                }
            },
            myStatus: {
                type: Number,
                default() {
                    return STATUS.outline
                }
            }
        },
        data() {
            return {
                myname: window.setting.userInfo.username,
                statusArr: [ STATUS.online, STATUS.waiting, STATUS.outline ],
                isWaiting: false
            }
        },
        methods: {
            async changeCaptain(player) {
                const myname = window.setting.userInfo.username;
                if (this.captain == player.username ||
                    myname == player.username
                ) {
                    return;
                }
                const confrimRes = window.confirm(`确定要指定${player.realname}为队长吗?`);
                this.isWaiting = true;
                if (confrimRes) {
                    const result = await postCaptain(player.username);
                    if (result.saved) {
                        setTimeout(() => {
                            dialog.msg('队长变更成功');
                            this.isWaiting = false;
                        }, 1000);
                    }
                }

            },
            async changePlayerStatus(status) {
                if (status == this.myStatus) {
                    return;
                }
                let result = null;
                this.isWaiting = true;
                const myname = window.setting.userInfo.username;
                if (status == STATUS.outline) {
                    result = await postOutline(myname);
                } else {
                    result = await postOnline(myname, status);
                }
                if (result.saved) {
                    setTimeout(() => {
                        this.isWaiting = false;
                    }, 1000);
                }

            },
            getUserStatus(status) {
                return getPlayerStatus(status);
            },
            setLiCls(player) {
                const status = parseInt(player.status);
                let cls = `status-${status}`;
                if (status == STATUS.outline &&
                    this.myname != player.username
                ) {
                    cls = `${cls} hide`;
                }
                // 如果是队长 那么加一个样式
                if (this.captain == player.username) {
                    cls = `${cls} captain`;
                }
                return cls;
            }
        }
    }
</script>

<style scoped>
    .change-status.waiting:after{
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(28,37,58,0.7) url("loading-pc.gif") center center no-repeat;
    }
    .appoint-captain{
        margin-bottom: 10px;
    }
    .change-status{
        padding-bottom: 20px;
    }
    .change-dl{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 10px;
    }
    .change-dt{
        color: #E4E41B;
        flex: 0 0 70px;
    }
    .change-dt-h2{
        font-size: 14px;
    }
    .change-dd{
        flex: 1;
    }
    .change-submit-btn button{
        width: 100%;
        display: block;
        background-color: #C4473D;
        color: #fff;
        line-height: 36px;
        border-radius: 20px;
    }
    .change-submit-btn button:active{
        background-color: #9F322A;
    }
    .change-avatar{
        display: inline-block;
        width: 50%;
        margin-bottom: 5px;
    }
    .change-dl-ul{
        display: flex;
        padding-right: 20px;
        padding-left: 5px;
    }
    .change-dl-li{
        display: inline-block;
        width: 65px;
        text-align: center;
        position: relative;
        opacity: 0.7;
    }
    .change-dl-li.captain{
        opacity: 1;
    }
    .change-dl-li .iscaptain{
        position: absolute;
        color: #fff;
        background-color: red;
        width: 40px;
        top: 0;
        left: 50%;
        margin-left: -20px;
        text-align: center;
        border-radius: 20px;
        font-size: 12px;
    }
    /* 离线 */
    .change-dl-li.status-0{
        opacity: 0.9;
        filter: grayscale(100%);
        filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1)
    }
    .change-dl-li.hide{
        display: none;
    }
    /* 正常 */
    .change-dl-li.status-1 p{
       color: #5FD667;
    }
    /* 挂机 */
    .change-dl-li.status-2 p{
        color: #ff7d46;
    }

    .mystatus-change{
        padding-top: 20px;
        padding-bottom: 10px;
    }
    .mystatus-change .change-dl-li{
        margin-right: 15px;
        opacity: 0.5;
    }
    .mystatus-change-p{
        line-height: 30px;
        border-radius: 20px;
        color: #fff;
    }
    .mystatus-change .change-dl-li[data-index="1"] .mystatus-change-p{
        background-color: #5FD667;
    }
    .mystatus-change .change-dl-li[data-index="2"] .mystatus-change-p{
        background-color: #ff8450;
    }
    .mystatus-change .change-dl-li[data-index="0"] .mystatus-change-p{
        background-color: #A8AFA8;
    }
    .mystatus-change .change-dl-li.active{
        opacity: 1;
    }
</style>
